import { render, staticRenderFns } from "./Lgx02654257955953151312164.vue?vue&type=template&id=09db68e1&"
import script from "./Lgx02654257955953151312164.vue?vue&type=script&lang=js&"
export * from "./Lgx02654257955953151312164.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports